import { modulePaths } from '@/routes/paths';
import type { CommercialOperationType } from '@/modules/commercial/types';

export function buildCommercialOperationNewUrl(options?: {
  reservationId?: string;
  clientId?: string;
  type?: CommercialOperationType;
}): string {
  const sp = new URLSearchParams();
  if (options?.reservationId) sp.set('reservation', options.reservationId);
  if (options?.clientId) sp.set('client', options.clientId);
  if (options?.type) sp.set('type', options.type);
  const q = sp.toString();
  return q
    ? `${modulePaths.commercial}/operaciones/nueva?${q}`
    : `${modulePaths.commercial}/operaciones/nueva`;
}

export function parseCommercialOperationPrefill(
  searchParams: URLSearchParams,
): {
  reservationId?: string;
  clientId?: string;
  type?: CommercialOperationType;
} {
  const reservationId = searchParams.get('reservation') ?? undefined;
  const clientId = searchParams.get('client') ?? undefined;
  const typeRaw = searchParams.get('type');
  const type =
    typeRaw === 'quotation' || typeRaw === 'rental' || typeRaw === 'sale'
      ? typeRaw
      : undefined;
  const out: {
    reservationId?: string;
    clientId?: string;
    type?: CommercialOperationType;
  } = {};
  if (reservationId) out.reservationId = reservationId;
  if (clientId) out.clientId = clientId;
  if (type) out.type = type;
  return out;
}
